// Web-Path for video, please click
// https://www.dropbox.com/scl/fi/m27hglp1wbmchv2jzx4cl/mainframe-vid-3.mp4?raw=1
export const MAINTENANCE = false;
export const VIDEO_PATH = '/vid/mainframe-vid.mp4';

/* GENERALS */
export const BUSINESS_NAME = 'Tomé & Martins Dienstleistungen'
export const BUSINESS_NAME_WITH_POSTFIX = 'Tomé & Martins GbR';
export const VALUE_ADDED_TAX_IDENTIFICATION = '[PLACEHOLDER]';
export const BUSINESS_IDENTIFICATION_NUMBER = '[PLACEHOLDER]';
export const BUSINESS_PAGE_URI = 'www.tomeundmartins.de';

/* Kontakt */
export const OFFICE_LOCATION_STREET = 'Gutenberg Str. 21';
export const OFFICE_LOCATION_PLACE = '55294 Bodenheim';
export const OFFICE_CONTACT_EMAIL = 'tome-martins@web.de';
export const OFFICE_CONTACT_OFFICE_PHONE_NUMBER = '+49 6135 7044080';
export const OFFICE_CONTACT_OFFICE_FAX_NUMBER = '+49 6135 7044081';
export const OFFICE_BUSINESS_CARDS_JORGE_PHONE_NUMBER = '+49 178 2589658';
export const OFFICE_BUSINESS_CARDS_PAULO_PHONE_NUMBER = '+49 178 8570289';


// WEBPACK FOOTER //
// ./src/env.js